var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-modal', {
    attrs: {
      "title": "Import Data",
      "ok-title": "Submit",
      "loading": _vm.loadingImport
    },
    on: {
      "ok": _vm.handleImportRh
    },
    scopedSlots: _vm._u([{
      key: "modal-header",
      fn: function fn() {
        return [_c('h5', {
          staticClass: "text-primary"
        }, [_vm._v("Import Data")]), _c('i', {
          staticClass: "fa fa-times cursor-pointer",
          on: {
            "click": function click($event) {
              _vm.showModal = false;
            }
          }
        })];
      },
      proxy: true
    }]),
    model: {
      value: _vm.showModal,
      callback: function callback($$v) {
        _vm.showModal = $$v;
      },
      expression: "showModal"
    }
  }, [[_c('div', {
    staticClass: "flex flex-column align-items-center"
  }, [_c('b-form-file', {
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "accept": ".xlsx, .xls, .csv"
    },
    model: {
      value: _vm.importFile,
      callback: function callback($$v) {
        _vm.importFile = $$v;
      },
      expression: "importFile"
    }
  }), _c('small', {
    staticClass: "text-black"
  }, [_vm._v("accept: .xlsx, .xls, .csv")])], 1), !_vm.loadingExportTemplate ? _c('b-button', {
    staticClass: "mt-3 w-100",
    attrs: {
      "variant": "outline-primary"
    },
    on: {
      "click": _vm.handleExportTemplateRH
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v(" Download Template ")]) : _c('b-button', {
    staticClass: "mt-3 w-100",
    attrs: {
      "variant": "outline-primary"
    }
  }, [_c('b-spinner', {
    staticClass: "mr-2",
    staticStyle: {
      "width": "18px",
      "height": "18px"
    }
  }), _vm._v(" Downloading ")], 1)]], 2), _c('b-sidebar', {
    attrs: {
      "right": "",
      "width": "80%",
      "bg-variant": "white",
      "title": "Add New Running Hours",
      "header-class": "p-0",
      "shadow": "",
      "backdrop": ""
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function fn() {
        return [_c('div', {
          staticClass: "w-100 p-2 px-3 d-flex justify-content-between align-items-center",
          staticStyle: {
            "border-bottom": "1px solid",
            "font-size": "18px",
            "font-weight": "600"
          }
        }, [_c('i', {
          staticClass: "fa fa-close cursor-pointer",
          on: {
            "click": function click($event) {
              _vm.showCanvas = false;
            }
          }
        }), _c('p', {
          staticClass: "m-0"
        }, [_vm._v(_vm._s(_vm.selectedData ? 'Update' : 'Create') + " Running Hours")])])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.showCanvas,
      callback: function callback($$v) {
        _vm.showCanvas = $$v;
      },
      expression: "showCanvas"
    }
  }, [[_vm.showCanvas ? _c('form-running-hours', {
    attrs: {
      "isFormDetail": "",
      "selectedData": _vm.selectedData,
      "fleetDetail": _vm.fleetDetail
    },
    on: {
      "close": function close($event) {
        _vm.showCanvas = false;
      },
      "refetch": _vm.fetchData
    }
  }) : _vm._e()]], 2), _c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        var _vm$fleetDetail;
        return [_c('h5', {
          staticClass: "card-title text-primary"
        }, [_c('strong', [_vm._v("RUNNING HOUR - " + _vm._s((_vm$fleetDetail = _vm.fleetDetail) === null || _vm$fleetDetail === void 0 ? void 0 : _vm$fleetDetail.name))])])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        return [_c('b-row', [_c('b-col', {
          staticClass: "mb-3 d-flex",
          attrs: {
            "md": "6"
          }
        }, [_c('div', {
          staticClass: "d-flex"
        }, [_c('date-picker', {
          staticStyle: {
            "width": "240px"
          },
          attrs: {
            "range": "",
            "format": "DD MMM YYYY",
            "value-type": "DD-MM-YYYY"
          },
          model: {
            value: _vm.dateRange,
            callback: function callback($$v) {
              _vm.dateRange = $$v;
            },
            expression: "dateRange"
          }
        }), _c('b-button', {
          staticClass: "mx-2",
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": _vm.fetchData
          }
        }, [_vm._v("Apply Filter ")])], 1)]), _c('b-col', {
          staticClass: "d-flex justify-content-end",
          attrs: {
            "md": "6"
          }
        }, [_c('b-button', {
          staticClass: "mr-2 d-flex align-items-center",
          staticStyle: {
            "height": "max-content"
          },
          attrs: {
            "variant": "outline-primary",
            "disabled": _vm.loadingExport
          },
          on: {
            "click": _vm.handleExportRh
          }
        }, [!_vm.loadingExport ? [_c('i', {
          staticClass: "ri-download-2-line pl-1"
        }), _vm._v("Export ")] : [_c('b-spinner', {
          staticClass: "mr-2",
          attrs: {
            "small": ""
          }
        }), _vm._v("Exporting... ")]], 2), _c('b-button', {
          staticClass: "d-flex align-items-center",
          staticStyle: {
            "height": "max-content"
          },
          attrs: {
            "variant": "outline-primary"
          },
          on: {
            "click": function click($event) {
              _vm.showModal = true;
            }
          }
        }, [_c('i', {
          staticClass: "ri-upload-2-line pl-1"
        }), _vm._v("Import")]), _c('b-button', {
          staticClass: "mx-2",
          staticStyle: {
            "height": "max-content"
          },
          attrs: {
            "variant": "outline-primary"
          },
          on: {
            "click": function click($event) {
              return _vm.$router.push('/maintenance/adjustment-running-hours');
            }
          }
        }, [_vm._v("Adjustment Running Hours")]), _c('b-button', {
          staticStyle: {
            "height": "max-content"
          },
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": function click($event) {
              _vm.showCanvas = true;
              _vm.selectedData = null;
            }
          }
        }, [_vm._v("Add Running Hours")])], 1), _c('b-col', {
          attrs: {
            "md": "12"
          }
        }, [_c('table', {
          staticClass: "w-100 table-striped"
        }, [_c('thead', [_c('th', [_vm._v("Action")]), _c('th', [_vm._v("FLEET ")]), _c('th', [_vm._v("LAST DATE INPUT")]), _c('th', [_vm._v("ENGINE NAME")]), _c('th', [_vm._v("LAST INPUT RH")]), _c('th', [_vm._v("TOTAL RH")])]), !_vm.loading ? _c('tbody', [_vm._l(_vm.runningHours, function (item, i) {
          return _vm._l(item === null || item === void 0 ? void 0 : item.runningHours, function (subItem, j) {
            var _item$runningHours, _item$runningHours2, _vm$fleetDetail2, _item$runningHours3, _subItem$totalRunning;
            return _c('tr', {
              key: "".concat(i, "-").concat(j)
            }, [j === 0 ? _c('td', {
              staticClass: "bg-white",
              staticStyle: {
                "border-bottom": "1px solid #dee2e6"
              },
              attrs: {
                "rowspan": item === null || item === void 0 ? void 0 : (_item$runningHours = item.runningHours) === null || _item$runningHours === void 0 ? void 0 : _item$runningHours.length
              }
            }, [_c('b-dropdown', {
              attrs: {
                "text": "Action",
                "size": "sm",
                "variant": "outline-primary"
              }
            }, [_c('b-dropdown-item', {
              on: {
                "click": function click($event) {
                  _vm.showCanvas = true;
                  _vm.selectedData = item;
                }
              }
            }, [_vm._v("Update Running Hour")]), _c('b-dropdown-item', {
              on: {
                "click": function click() {
                  return _vm.handleDelete(item);
                }
              }
            }, [_vm._v("Delete Running Hour")])], 1)], 1) : _vm._e(), j === 0 ? _c('td', {
              staticClass: "bg-white",
              staticStyle: {
                "border-bottom": "1px solid #dee2e6"
              },
              attrs: {
                "rowspan": item === null || item === void 0 ? void 0 : (_item$runningHours2 = item.runningHours) === null || _item$runningHours2 === void 0 ? void 0 : _item$runningHours2.length
              }
            }, [_c('b-badge', {
              staticClass: "px-3 py-2",
              staticStyle: {
                "font-size": "small"
              },
              attrs: {
                "variant": "success"
              }
            }, [_vm._v(_vm._s((_vm$fleetDetail2 = _vm.fleetDetail) === null || _vm$fleetDetail2 === void 0 ? void 0 : _vm$fleetDetail2.name))])], 1) : _vm._e(), j === 0 ? _c('td', {
              staticClass: "bg-white",
              staticStyle: {
                "border-bottom": "1px solid #dee2e6"
              },
              attrs: {
                "rowspan": item === null || item === void 0 ? void 0 : (_item$runningHours3 = item.runningHours) === null || _item$runningHours3 === void 0 ? void 0 : _item$runningHours3.length
              }
            }, [_vm._v(_vm._s(_vm.formatDate(item === null || item === void 0 ? void 0 : item.date)))]) : _vm._e(), _c('td', [_vm._v(_vm._s(subItem === null || subItem === void 0 ? void 0 : subItem.powerType))]), _c('td', [_vm._v(_vm._s(subItem === null || subItem === void 0 ? void 0 : subItem.dailyRunningHoursFormatted))]), _c('td', [_vm._v(_vm._s((_subItem$totalRunning = subItem === null || subItem === void 0 ? void 0 : subItem.totalRunningHoursFormatted) !== null && _subItem$totalRunning !== void 0 ? _subItem$totalRunning : '-'))])]);
          });
        })], 2) : _c('tbody', [_c('tr', [_c('td', {
          attrs: {
            "colspan": "6"
          }
        }, [_c('div', {
          staticClass: "w-100 d-flex justify-content-center py-5"
        }, [_c('b-spinner')], 1)])])])]), _c('div', {
          staticClass: "mt-4 d-flex align-items-center w-100 justify-content-end"
        }, [_c('b-pagination', {
          staticClass: "mb-0 mr-3",
          attrs: {
            "total-rows": _vm.meta.totalItems,
            "per-page": _vm.meta.limit,
            "first-number": "",
            "align": "center"
          },
          on: {
            "change": function change(page) {
              _vm.meta.page = page;
              _vm.fetchData();
            }
          },
          model: {
            value: _vm.meta.page,
            callback: function callback($$v) {
              _vm.$set(_vm.meta, "page", $$v);
            },
            expression: "meta.page"
          }
        }), _c('b-form-select', {
          staticStyle: {
            "width": "140px"
          },
          attrs: {
            "plain": "",
            "options": _vm.limitOptions
          },
          on: {
            "input": _vm.fetchData
          },
          model: {
            value: _vm.meta.limit,
            callback: function callback($$v) {
              _vm.$set(_vm.meta, "limit", $$v);
            },
            expression: "meta.limit"
          }
        })], 1)])], 1)];
      },
      proxy: true
    }])
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }